import { useSelector } from "react-redux";
import { getAppraisalData, getVehicle } from "../../store/selectors";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateMultiMatchVehicle } from "../../store/slices/Appraisal";
import { AppDispatch } from "../../types/AppDispatch";

export const useVehicleVariant = () => {
  const getBodyTypes = () => {
    const allBodyTypes = vehicle?.multiMatches?.map(
      (vehicle: IMultiMatch) => vehicle.bodyType
    );
    const uniquBodyTypes: string[] = Array.from(new Set(allBodyTypes));
    return uniquBodyTypes;
  };

  const MIN_VARIANTS = 2;
  const MIN_BODYTYPES = 1;
  const vehicle = useSelector(getVehicle);
  const { appraisalSessionId } = useSelector(getAppraisalData);
  const [loading, setLoading] = useState(false);
  const [selectedBodyType, setSelectedBodyType] = useState<string | null>();
  const [openModal, setOpenModal] = useState(false);
  const [bodyTypesToFilter, setBodyTypesToFilter] = useState<string[] | null>(
    getBodyTypes()
  );
  const [filteredVariants, setFilteredVariants] = useState<IMultiMatch[]>(
    vehicle.multiMatches
  );
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const showFilter =
    vehicle?.multiMatches?.length > MIN_VARIANTS &&
    getBodyTypes().length > MIN_BODYTYPES;
  const showVariants = !showFilter || selectedBodyType;

  const handleSelectClick = (capCode: string) => {
    if (capCode) {
      setLoading(true);
      dispatch(
        updateMultiMatchVehicle({
          appraisalSessionId,
          selectedCapCode: capCode
        })
      ).then(() => {
        navigate("/mileage");
      });
      return;
    }
  };

  const filterByBodyType = (bodyType: string) => {
    const filteredResults = [...vehicle.multiMatches].filter(
      (variant) => variant.bodyType === bodyType
    );
    setFilteredVariants(filteredResults);
  };

  const onChangeBodyType = (filterBy: string) => {
    setSelectedBodyType(filterBy);
    filterByBodyType(filterBy);
  };

  return {
    bodyTypesToFilter,
    filteredVariants,
    handleSelectClick,
    loading,
    onChangeBodyType,
    openModal,
    selectedBodyType,
    setOpenModal,
    showFilter,
    showVariants,
    vehicle
  };
};
